export default __webpack_public_path__ + "static/media/ios-info.dd8b95f7.svg";